<template>
  <div>
    <el-main>
      <SsgMessagebox
        titles="导入背调人"
        v-if="maskshow && masktype == 'back'"
        width="500px"
        height="370px"
        @sub="subname"
        @shut="shutname">
        <el-upload
        
          class="upload-demo"
          ref="upload"
          drag
          :with-credentials="true"
          :action="uploadurl"
          :on-change="uploadChange"
          :on-success="importSuccess"
          :data="form"
          :before-upload="beforeAvatarUpload"
          :on-progress="onupload"
          :auto-upload="false"
          :file-list="fileList"
          :show-file-list="true"
          :on-remove="handleRemove">
          <div   v-if="fileList.length <= 0" style="margin-top:10px">
            <!-- <i class="el-icon-upload"></i> -->
               <svg-icon
                icon-class="uploud"
                style="font-size: 40px; margin-right: 10px;color:#6669e3"></svg-icon>
            <div class="el-upload__text">点击或拖拽上传</div>
            <div
              class="el-upload__text"
              style="color: #8a8a9a; font-size: 12px; margin-top: 10px">
              <span>支持excel格式，只能上传一份</span>
            </div>
          </div>
                <div v-else style="margin-top:10px">
            <!-- <i class="el-icon-upload"></i> -->
               <svg-icon
                icon-class="uploud"
                style="font-size: 40px; margin-right: 10px;color:#6669e3"></svg-icon>
            <div class="el-upload__text">点击或拖拽上传</div>
            <div
              class="el-upload__text"
              style="color: #8a8a9a; font-size: 12px; margin-top: 10px">
              <span>支持excel格式，只能上传一份，重新上传会覆盖上一份文件</span>
            </div>
          </div>
        </el-upload>
                  <div v-if="fileList.length > 0"  class="bottfle">
            <div>
              <svg-icon
                icon-class="wenjian"
                style="font-size: 16px; margin-right: 10px"></svg-icon>
              <span class="name">{{ this.fileName }}</span>
              <span class="size">{{ filesize }}</span>
            </div>
            <div style="cursor: pointer" @click="delet">
              <svg-icon
                icon-class="delete"
                style="font-size: 14px; color: #8a8a9a; margin-right: 5px"></svg-icon>
              <span class="name">删除</span>
            </div>
          </div>
        <!-- <div v-else>
          <el-upload
            class="upload-demo"
            ref="upload"
            drag
            :with-credentials="true"
            :action="uploadurl"
            :on-change="uploadChange"
            :on-success="importSuccess"
            :data="form"
            :before-upload="beforeAvatarUpload"
            :on-progress="onupload"
            :auto-upload="false"
            :file-list="fileList"
            :show-file-list="true"
            :on-remove="handleRemove">
   
          </el-upload>
        
        </div> -->

        <div style="margin-top: 16px">
          <span class="zip">点击下载</span>
          <span class="moban" @click="downloadTmp">导入模板</span>
        </div>
      </SsgMessagebox>
      <div class="sign adaptation">
        <div class="tab_nav" style="height: 0px">
          <div class="nav">
            <div>
              <a @click="$router.go(-1)"> 返回 </a>
            </div>
            |
            <div>背调列表</div>
            <div>></div>
            <div>添加背调人</div>
          </div>
        </div>
        <div class="title">
          <p>添加背调人</p>
        </div>
        <div class="centercontent">
          <div class="content">
            <el-form
              label-width="120px"
              ref="itemInfo"
              :rules="rules"
              :model="itemInfo"
              label-position="right">
              <div class="titleLine">
                <h4>背调项目设置</h4>
              </div>
              <div class="item">
                <el-form-item label="项目类型" prop="projectType">
                  <el-radio-group
                    class="ident"
                    v-model="itemInfo.projectType"
                    @change="changeResult">
                    <el-radio class="btn1" label="1">RPO</el-radio>
                    <el-radio class="btn1" label="2">嗖嗖管</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="项目名称" prop="projectName">
                  <el-select
                    placeholder="请输入"
                    style="width: 450px"
                    :value="itemInfo.projectName"
                    filterable
                    remote
                    no-data-text='未搜索到相关项目'
                    :remote-method="remoteMethod"
                    @change="handleChange">
                    <el-option
                      v-for="item in options"
                      v-html="item.projectName + '  (项目ID：'+ item.projectId+')'"
                      :key="item.value"
                      :label="item.projectName + '  (项目ID：'+ item.projectId+')'"
                      :value="item.projectId"></el-option>
                  </el-select>
                  <span class="absol">请输入项目名称关键字并在搜索结果中选择项目</span>
                </el-form-item>
                <!-- <el-form-item label="项目名称" prop="itemName">
                  <el-input
                    v-model.trim="itemInfo.itemName"
                    placeholder="请输入项目名称"
                    maxlength="20></el-input>
                  <span class="absol">请输入项目名称关键字并在搜索结果中选择项目</span>
                </el-form-item> -->
                <el-form-item label="项目ID：" v-if="itemInfo.projectName">
                  <span class="abspan">{{ itemInfo.projectId }}</span>
                </el-form-item>
                <el-form-item label="项目经理：" v-if="itemInfo.projectName">
                  <span class="abspan">{{ itemInfo.projectUserName }}</span>
                </el-form-item>
                <el-form-item
                  label="背调查询项"
                  class="groups"
                  prop="checkList">
                  <div style="margin-top: 5px">
                    <el-checkbox-group v-model="itemInfo.checkList" @change="handleChecked">
                      <div v-for="(v,k) in candidate" :key="k">
                        <el-checkbox  :label="v.id" >{{v.name}}</el-checkbox>
                        
                      </div>
                    <!-- <el-checkbox v-model="itemInfo.checkList.itemAntiFraud">羊毛反欺诈查询</el-checkbox>
                    <el-checkbox v-model="itemInfo.checkList.itemFinancialBlacklistIdcard">金融黑名单查询（身份证）</el-checkbox>
                    <el-checkbox v-model="itemInfo.checkList.itemFinancialBlacklistBank">金融黑名单查询（银行卡）</el-checkbox>
                    <el-checkbox v-model="itemInfo.checkList.itemFinancialBlacklistTel">金融黑名单查询（手机号）</el-checkbox> -->
                    </el-checkbox-group>
                  </div>
                </el-form-item>
              </div>
              <div class="titleLine">
                <h4>背调授权设置</h4>
              </div>
              <el-form-item label="授权公司名称" prop="authCompanyFullName">
                <el-input
                  v-model.trim="itemInfo.authCompanyFullName"
                  placeholder="请输入授权公司名称"></el-input>
                <span class="absol">显示于用户授权协议中，请填写甲方客户公司全称</span>
              </el-form-item>
              <el-form-item label="授权短信签名" prop="authMsgSign">
                <el-input
                  v-model.trim="itemInfo.authMsgSign"
                  placeholder="请输入授权短信签名"></el-input>
                <span class="absol">显示于用户授权短信的开头，请填写甲方客户公司简称或品牌名称</span>
              </el-form-item>
              <el-form-item label="授权短信签名" prop="authMsgTemplate">
                <span class="abspan" style="color: #8a8a9a">模板变量：</span>
                <el-button
                  size="medium"
                  @click="addSMS('#用户姓名#')"
                  class="btn">#用户姓名#</el-button>
                <el-button
                  size="medium"
                  @click="addSMS('#背调链接#')"
                  class="btn">#背调链接#</el-button>
                <el-input
                
                  type="textarea"
                  placeholder="请输入内容"
                  @change="handelin"
                  v-model="itemInfo.authMsgTemplate"
                  show-word-limit
                  maxlength="500">
                </el-input>
              </el-form-item>
              <div class="titleLine">
                <h4>添加背调人</h4>
              </div>
              <span class="abspan" style="color: #8a8a9a; margin-left: 10px">说明：</span>
              <div class="backman">
                <div>
                  <p class="abspan" style="color: #8a8a9a; margin-left: 10px">
                    1、可以手动逐条添加背调人，或者通过excel导入。
                  </p>
                  <p class="abspan" style="color: #8a8a9a; margin-left: 10px">
                    2、只能对项目内的候选人/员工进行背调。
                  </p>
                  <p class="abspan" style="color: #8a8a9a; margin-left: 10px">
                    3、可对项目内的同一人进行多次背调。若背调人录入时已经被背调过，列表中会有提示
                  </p>
                </div>
                <div style="margin-top: 40px">
                  <el-button
                    size="medium"
                    @click="uploadBack"
                    class="btn subbtn">导入背调人</el-button>
                </div>
              </div>
              <div class="table">
                <el-table :data="itemInfo.biDatas">
                  <el-table-column
                    label="操作"
                    prop="name"
                    min-width="2"
                    align="left">
                    <template slot-scope="scope">
                      <p
                        class="delete"
                        style="color: #6669e3; cursor: pointer"
                        @click="dele(scope.$index)">
                        删除
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="姓名"
                    prop="name"
                    min-width="10"
                    align="left">
                    <template slot-scope="scope">
                      <el-form-item
                        :prop="'biDatas.' + scope.$index + '.name'"
                        :rules="rules1.name">
                        <el-input
                          v-model.trim="scope.row.name"
                          placeholder="请输入"
                          maxlength="20"></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="手机号"
                    prop="mobile"
                    min-width="10"
                    align="left">
                    <template slot-scope="scope">
                      <el-form-item
                        :prop="'biDatas.' + scope.$index + '.mobile'"
                        :rules="rules1.mobile">
                        <el-input
                          v-model.trim="scope.row.mobile"
                          placeholder="请输入"
                          maxlength="11"
                          >
                        </el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <el-button
                style="margin-top: 10px"
                class="btn"
                size="medium"
                @click="addBack">
                <span style="font-size: 16px; font-weight: bold">+</span>
                添加背调人
              </el-button>
            </el-form>
          </div>
        </div>

        <div class="btndiv">
          <button
            class="btn"
            type="button"
            @click="$router.go(-1)"
            tag="button">
            取消
          </button>
          <button class="btn subbtn" @click="addOrg" type="button">
            确认并发送授权短信
          </button>
        </div>
      </div>
    </el-main>
  </div>
</template>
<script>
export default {
  created() {
    // this.loadData();
  },

  data() {
    var checkAge = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('标题不能为空'));
      }
      callback();
    }
    return {
      form: {},
      acceptType: ".excel",
      uploadurl: this.$axios.defaults.baseURL + "/bi/decodeBIData",
      uploadEntry: {},
      maskshow: false,
      masktype: "",
      rules: {
        checkList:[{
            required: true,
            message: "请选择背调查询项",
            trigger: "change",
        }],
        projectType: [
          {
            required: true,
            message: "请选择项目类型",
            trigger: "change",
          },
        ],
        projectName: [
          {
            required: true,
            message: "请输入项目名称",
            trigger: "change",
          },
        ],

        authMsgSign: [
          {
            required: true,
            message: "请输入授权短信签名",
            trigger: "blur",
          },
        ],
        authCompanyFullName: [
          {
            required: true,
            message: "请输入授权公司名称",
            trigger: "blur",
          },
        ],
        authMsgTemplate: [
          { required: true, message: "请输入模板内容", trigger: "change" },
        ],
      },
      rules1: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
         {
            validator: function (rule, value, callback) {
              if (/^1[3456789]\d{9}$/.test(value) == false) {
                callback(new Error("手机号格式错误"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
          ],
      },

      options: [],
      fileList: [],
      fileName: "",
      filesize: "",
      fileLength: "",
      serchnanme:'',
      projectName:'',
      info:{},
      itemInfo: {
        projectType: "", //项目类型
        projectName: "", //项目名称
        projectId: "",
        itemBadInfo: 0,
        itemAntiFraud: 0,
        itemFinancialBlacklistIdcard: 0,
        itemFinancialBlacklistBank: 0,
        itemFinancialBlacklistTel: 0,
        authMsgSign: "", //授权短信
        authCompanyFullName: "", //授权公司
        projectUserName: "", //项目经理
        authMsgTemplate: "",
        projectUserId:'',
        biDatas: [
        
        ],
        checkList:[]
      },
      candidate:[
        {
          name:'不良信息核查',
          id:'itemBadInfo',
        },
         {
          name:'羊毛反欺诈查询',
          id:'itemAntiFraud',
        },
         {
          name:'金融黑名单查询（身份证）',
          id:'itemFinancialBlacklistIdcard',
        },
         {
          name:'金融黑名单查询（银行卡）',
          id:'itemFinancialBlacklistBank',
        },
         {
          name:'金融黑名单查询（手机号）',
          id:'itemFinancialBlacklistTel',
        }
        
      ],
      iablke: [],
    };
  },
  methods: {
    base(val){
        
    },
    handleChecked(val){
      this.itemInfo.checkList = val
     
    },
    handelin(val){
        
          // this.iablke = val
          // this.iablke = []
          this.itemInfo.authMsgTemplate = val
          // this.addSMS()
    },
    downloadTmp() {
      this.$confirm('下载到本地, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				// type: 'warning'
				iconClass: "el-icon-caveat",
			}).then(() => {
				this.$axios.post("/bi/exportTemplate", '', {
					responseType: 'blob'
				}, { headers: {'Content-Type': 'application/x-www-form-urlencoded'} }).then(res => {
					  let blob = res.data
						let a = document.createElement('a')
						let headers = res.headers;
						let fileName = headers['content-disposition'];
						a.download = decodeURI(fileName).replace("attachment;filename=", '');
						a.href = URL.createObjectURL(blob)
						document.body.appendChild(a)
						a.click()
						document.body.removeChild(a)
					})
				}).catch(err => {
					console.log(err);
				})
    },
    changeResult(e) {
      if (e == 1) {
        this.options = [];
        this.itemInfo.projectName = "";
        this.itemInfo.projectUserName = "";
        this.itemInfo.projectId = "";
        this.itemInfo.projectUserId = ''
      } else {
        this.options = [];
        this.itemInfo.projectName = "";
        this.itemInfo.projectUserName = "";
        this.itemInfo.projectId = "";
        this.itemInfo.projectUserId = ''

      }
    },
    loadData() {
      return this.$axios.get("project/info?id=" + this.$route.query.id)
        .then((res) => {
          this.itemInfo.name = res.data.data.project.projectName;
          this.itemInfo.industryName = res.data.data.project.industryName;
          this.itemInfo.manger = res.data.data.project.userName;
          this.itemInfo.mangerId = res.data.data.project.userId;
          this.itemInfo.mobile = res.data.data.project.mobile;
          this.itemInfo.orgName = res.data.data.project.orgName;
          this.checklist.contractCompany = res.data.data.contract;
          this.contractIds = res.data.data.contract.toString();
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
    //文件上传前检查
    beforeAvatarUpload(file, fileList) {
      const extension = file.name.split(".")[1];
      const array = ["excel"];
      if (!array.includes(extension)) {
        this.$message.error("暂不支持该文件格式，建议选择 excel 格式文件");
        return false;
      }
    },
    // 文件上传时的钩子
    onupload() {
      // this.loading = true;
    },
    // 上传文件成功
    importSuccess(response, file, fileList) {
      if (response.status === 1) {
        this.$message.success(response.message);
        this.$router.go(-1);
      } else {
        this.$message.error(response.message);
      }
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    delet() {
      this.fileList = [];
    },
    addBack() {
      this.itemInfo.biDatas.push({ name: "", mobile: "" });
    },
    uploadChange(file, fileList) {
      this.fileName = file.name;
      var size = (file.size / 1024).toFixed(2) + "KB";
      this.filesize = size;

      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]]; // 这一步，是 展示最后一次选择的csv文件
      }
    },
    //上传文件限制
    // limitPrompt() {
    //  if (this.fileType == "EXCEL") {
    //     this.$message.error("最多上传1份文件");
    //   }
    // },
    dele(val) {
      this.itemInfo.biDatas.splice(val, 1);
    },
    addSMS(variableName) {                 
      // this.iablke.push(variableName);
     
      // this.itemInfo.authMsgTemplate = this.iablke.toString().replace(/,/g, "");
      this.itemInfo.authMsgTemplate += variableName;
    },
    shutname() {
      this.maskshow = false;
      this.masktype = "";
    },
    subname() {
      if (this.fileList.length > 0) {
        var formData = new FormData();
        this.fileList.forEach((file) => {
          formData.append("file", file.raw);
        });
        this.$axios.post(this.uploadurl, formData)
          .then((res) => {
            if (res.data.status == 1) {
              this.maskshow = false;
              this.masktype = "back";
              res.data.data.forEach((val) => {
                this.itemInfo.biDatas.push({name:val.name,mobile:val.mobile});
              });
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        this.$message.error("请导入被调人");
      }
    },
    uploadBack() {
      this.fileList = []
      this.maskshow = true;
      this.masktype = "back";
    },
    //文件上传前检查
    beforeAvatarUpload(file) {
      const extension = file.name.slice(file.name.lastIndexOf("."));
      const array = [".jpg", ".docx", ".doc", ".jpeg", ".pdf", ".png"];
      if (!array.includes(extension)) {
        this.$message.error("暂不支持该文件格式，建议选择 jpg、jpeg、png、doc、docx、pdf 格式文件");
        return false;
      }
    },
    // 上传成功后的回调
    uploadSuccess(response, file, fileList) {
      if (response.status == 1) {
        this.$message({
          message: response.message,
          type: "success",
        });
        //刷新数据
        this.loadData();
      } else if (response.status == 0) {
        this.$message({
          message: response.message,
          type: "error",
        });
      }
    },
    remoteMethod(query) {
      this.serchnanme = query
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.$axios
            .get(
              "/bi/queryProjectData?projectName=" +
                query +
                "&projectType=" +
                this.itemInfo.projectType
            )
            .then((res) => {
              if (res.data.status == 1) {
                this.options = res.data.data;
                this.options.map((item) => {
                  item.projectName = this.brightKeyword(item.projectName);
                });
              } else {
                this.$message.error(res.data.message);
              }
            })
            .catch((err) => {
              console.error(err);
            });
        }, 200);
      } else {
        this.options = [];
      }
    },
    brightKeyword(val) {
      let keyword = this.serchnanme;
      if (val.indexOf(keyword) > -1) {      
        return val.replace(keyword, `<span style='color:#6669e3'>${keyword}</span>`);
      } else {
        return val;
      }
    },
    handleChange(val) {
      this.itemInfo.projectId = val;
      var obj = {};
      obj = this.options.find(function (item) {
        return item.projectId === val;
      });
      this.itemInfo.projectName = obj.projectName.replace(`<span style='color:#6669e3'>${this.serchnanme}</span>`,this.serchnanme)+'  (项目ID：'+ obj.projectId+')'
      this.itemInfo.projectUserName = obj.projectUserName;
      this.itemInfo.projectUserId = obj.projectUserId
    },
    //过滤
    addOrg() {      
      this.$refs.itemInfo.validate((valid) => {
        if (valid) {
            if (this.itemInfo.checkList.includes('itemBadInfo') ) {
            this.itemInfo.itemBadInfo = 1
          } else {
            this.itemInfo.itemBadInfo = 0
          }

          if (this.itemInfo.checkList.includes('itemAntiFraud')  ) {
            this.itemInfo.itemAntiFraud = 1
          } else {
            this.itemInfo.itemAntiFraud = 0
          }

          if (this.itemInfo.checkList.includes('itemFinancialBlacklistIdcard') ) {
            this.itemInfo.itemFinancialBlacklistIdcard = 1
          } else {
            this.itemInfo.itemFinancialBlacklistIdcard = 0
          }

          if (this.itemInfo.checkList.includes('itemFinancialBlacklistBank') ) {
            this.itemInfo.itemFinancialBlacklistBank = 1
          } else {
            this.itemInfo.itemFinancialBlacklistBank = 0
          }

          if (this.itemInfo.checkList.includes('itemFinancialBlacklistTel') ) {
            this.itemInfo.itemFinancialBlacklistTel = 1
          } else {
            this.itemInfo.itemFinancialBlacklistTel = 0
          }
        
      
       this.itemInfo.projectName = this.itemInfo.projectName.replace(/\([^\)]*\)/g,"")
       if(!this.itemInfo.biDatas.length){
         this.$message.error('背调人不能为空');
         return
       }
       //深拷贝
          this.info = JSON.parse(JSON.stringify(this.itemInfo));
          const params = this.info;
          delete params.checkList    
          this.$axios.post("/bi/insertBiProject", params).then((res) => {
            if (res.data.status == 1) {
              this.$router.push({
                path: "/main/ssgBacktone",
              });
              this.$message.success(res.data.message);
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    }
  }
};
</script>


<style src="../../assets/css/common/nav.less" scoped lang="less"></style>
<style scoped lang="less">
.el-main {
  height: calc(100vh - 60px);
}
.box {
  display: flex;
  margin-top: 20px;

  .return {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    margin-right: 20px;
    cursor: pointer;
  }

  .line {
    margin-right: 20px;
    color: #606266;
  }

  .lines {
    margin-right: 20px;
    color: #606266;
    font-weight: bold;
  }

  .back:hover {
    color: #6669e3;
    cursor: pointer;
  }

  .contract {
    margin-right: 20px;

    font-size: 12px;
    font-weight: 400;
    color: rgba(138, 138, 154, 1);
  }
}

.btndiv {
  display: flex;
  justify-content: center;
  margin: 80px 0;
  margin-bottom: 40px;
  padding-bottom: 50px;

  .subbtn {
    margin-left: 10px;
  }
}
.content {
  display: flex;
  justify-content: center;
}
.sign {
  width: 100%;
  height: 100%;
  padding: 0 50px;
  box-sizing: border-box;

  /*background-color: #fff;
          border: 1px solid #d9dbe2;
          border-radius: 6px 6px 0 0;*/
  .operating {
    width: 100%;
    min-height: 62px;
    line-height: 62px;
    box-sizing: border-box;

    .search {
      margin-right: 14px;
    }
  }
}

.title {
  display: flex;
  justify-content: center;
  margin: 30px 0;
  p {
    font-size: 24px;
    font-weight: bold;
    color: rgba(48, 49, 64, 1);
    line-height: 36px;
  }
}

.el-form-item__label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 5px 0 0;
  box-sizing: border-box;
}
.centercontent {
  // margin-left: 180px;
}
.absol {
  position: absolute;
  width: 400px;
  margin-left: 8px;
  font-size: 12px;
  font-weight: 400;
  color: #8a8a9a;
}
.abspan {
  font-size: 12px;
  font-weight: 400;
  color: #303140;
}
.groups /deep/ .el-checkbox {
  display: block;
  color: #303140;
  line-height: 32px;
}
.el-form-item /deep/ .el-form-item__content {
  width: 450px;
}
.item /deep/ .el-form-item {
  margin-bottom: 20px;
}
.el-form-item /deep/ .el-textarea {
  width: 800px;
  height: 100px;
  margin-top: 10px;
}
.el-form-item /deep/ .el-textarea__inner {
  height: 100px;
}
.el-form-item /deep/ .el-textarea + .el-form-item__error {
  top: inherit;
  right: -300px;
  bottom: 19px;
}
.el-form-item /deep/ .el-form-item__label {
  width: 105px !important;
}
.el-form-item /deep/ .el-form-item__content {
  margin-left: 110px !important;
}
.backman {
  width: 910px;
  display: flex;
  justify-content: space-between;
}
.el-table__row .el-form-item /deep/ .el-form-item__content {
  margin-left: 0 !important;
  width: 350px !important;
}
.table /deep/ .el-form-item {
  margin-bottom: 0px !important;
}
.upload-demo /deep/ .el-upload {
  width: 436px;
  height: 146px;
  border: 1px solid #e2e5ed;
  border-radius: 4px;
}
.upload-demo /deep/ .el-upload-dragger {
  background-color: #fff;
  border: 1px dashed #d9d9d9;
  border-radius: 0px;
  box-sizing: border-box;
  width: 425px;
  height: 136px;
  text-align: center;
  margin: 5px auto;
  position: relative;
  overflow: hidden;
}
.upload-demo /deep/ .el-upload-dragger .el-icon-upload {
  font-size: 67px;
  color: #c0c4cc;
  margin: 9px 0 16px;
  line-height: 50px;
}
.upload-demo /deep/ .el-upload-dragger .el-icon-upload {
  font-size: 55px;
  color: #6669e3;
  margin: 9px 0 5px;
  line-height: 50px;
}
.upload-demo /deep/ .el-upload-dragger .el-upload__text {
  color: #6669e3;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
}
.upload-demo /deep/ .el-upload-list__item-name {
  display: none;
}
.zip {
  font-size: 12px;
  color: #303140;
  font-weight: 400;
}
.moban {
  font-size: 12px;
  color: #6669e3;
  font-weight: 400;
  cursor: pointer;
}
.certs {
  display: flex;
  justify-content: center;
  margin: 35px auto;
}
.bottfle {
  display: flex;
  justify-content: space-between;
  margin: 0 20px;
  .name {
    font-size: 12px;
    font-weight: 400;
    color: #545566;
  }
  .size {
    font-size: 12px;
    font-weight: 400;
    color: #8a8a9a;
    margin-left: 10px;
  }
}
.table /deep/ .el-form-item__error {
  top: 50%;
	right: 30px;
	left: inherit;
	margin-top: -10px;
}
/deep/ .messagebox .content {
    padding: 13px 25px !important;
}


</style>
